export default "__VITE_PUBLIC_ASSET__c0422035__"